// extracted by mini-css-extract-plugin
module.exports = {"container":"VerifyEmail_container__2JiKi","spinner":"VerifyEmail_spinner__27iNF","shake-horizontal":"VerifyEmail_shake-horizontal__14oqG","grow":"VerifyEmail_grow__23gD8"};